import { useState, useEffect, useCallback } from 'react';
import messageService from '../services/messageService';
import { useAuth } from '../contexts/AuthContext';

const useUnreadMessages = () => {
  const { user, isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    if (!isAuthenticated || !user) {
      setUnreadCount(0);
      return;
    }
    try {
      const response = await messageService.getUnreadMessageCount();
      if (response.success) {
        setUnreadCount(response.count);
      }
    } catch {
      setUnreadCount(0);
    }
  }, [user, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && user) {
      fetchUnreadCount();
      const interval = setInterval(fetchUnreadCount, 30000);
      return () => clearInterval(interval);
    } else {
      setUnreadCount(0);
    }
  }, [user, isAuthenticated, fetchUnreadCount]);

  return { unreadCount };
};

export default useUnreadMessages;
